import { foundationContext } from '@philips-internal/oswald-ui-foundation/lib/context';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { setupTheme } from './theme';
import { setupLocalization } from './localization';
import { setupAuthentication } from './authentication';
import { setupModules } from './modules';
import Audit from './audit';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services/history-service';

const FOUNDATION_DATA_CONTEXT = new DataContext();

function getFoundationDataContext(): DataContext {
  return FOUNDATION_DATA_CONTEXT;
}

function bootstrap(): Promise<void> {

  foundationContext.setCanEditSector(false);
  foundationContext.setCanEditProfile(false);

  setupAuthentication();
  setupModules();
  setupLocalization();
  setupTheme();

  const audit = new Audit();
  audit.routeChangeLog(HistoryService.getCurrentRoute());

  return Promise.all(
    [
      setupLocalization(),
    ])
    .then(() => Promise.resolve());
}

export { bootstrap as default, getFoundationDataContext };
